import { EProjectSection, trackEventV2 } from '@/services/analytics/trackEventV2';

import {
  EChatbotEventName,
  IChatbotErrorEvent,
  IChatbotEvent,
  IChatbotRentalSearchEvent,
} from './types';

export function trackChatbotNewConverstationStarted(data: IChatbotEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_NEW_CONVERSATION_STARTED, EProjectSection.MARKETPLACE, {
    ...data,
  });
}

export function trackChatbotOpened(data: IChatbotEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_OPENED, EProjectSection.MARKETPLACE, { ...data });
}

export function trackChatbotClosed(data: IChatbotEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_CLOSED, EProjectSection.MARKETPLACE, { ...data });
}

export function trackChatbotResetChat(data: IChatbotEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_RESET_CHAT, EProjectSection.MARKETPLACE, { ...data });
}

export function trackChatbotShowMoreClicked(data: IChatbotRentalSearchEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_SHOW_MORE_CLICKED, EProjectSection.MARKETPLACE, {
    ...data,
  });
}

export function trackChatbotRefineSearchClicked(data: IChatbotRentalSearchEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_REFINE_SEARCH_CLICKED, EProjectSection.MARKETPLACE, {
    ...data,
  });
}

export function trackChatbotTripPlannerRentalSearchResultsDisplayed(
  data: IChatbotRentalSearchEvent,
) {
  trackEventV2(EChatbotEventName.CHATBOT_TRIP_PLANNER_RENTAL_SEARCH, EProjectSection.MARKETPLACE, {
    ...data,
  });
}

export function trackChatbotError(data: IChatbotErrorEvent) {
  trackEventV2(EChatbotEventName.CHATBOT_ERROR, EProjectSection.MARKETPLACE, {
    ...data,
  });
}

export * from './types';
